import React from 'react';
import { Link } from 'react-router-dom';
import ProductImage from './ProductImage';
import { products } from './productData';

function Products() {
  return (
    <div className="section products-section reveal">
      <div className="content">
        <div className="section-heading-row practical-heading">
          <div>
            <p className="eyebrow">Product range</p>
            <h2>Ten cattle feed supplements showcased individually.</h2>
          </div>

          <p>
            Every product remains an individual card and detail page. Categories
            are used as badges and for the backend image-folder structure only,
            so future photos stay organized without hiding products inside
            category sections.
          </p>
        </div>

        <div className="product-grid commercial-product-grid">
          {products.map((product) => (
            <article className="product-card" key={product.slug}>
              <div className="product-image-wrap">
                <ProductImage product={product} />
              </div>

              <div className="product-card-body">
                <span className="product-category">
                  {product.category}
                </span>

                <h3>{product.name}</h3>

                <p>{product.description}</p>

                <div className="product-commercial-block">
                  <strong>Practical benefits</strong>

                  <ul className="mini-list">
                    {product.benefits
                      .slice(0, 3)
                      .map((benefit) => (
                        <li key={benefit}>{benefit}</li>
                      ))}
                  </ul>
                </div>

                <p className="packaging-line">
                  <strong>Available:</strong>{' '}
                  {product.packaging.join(' | ')}
                </p>

                <div className="product-actions">
                  <Link
                    to={`/products/${product.slug}`}
                    className="btn secondary"
                  >
                    Request Details
                  </Link>

                  <Link
                    to="/contact"
                    className="text-link"
                  >
                    Bulk Inquiry →
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Products;
